
import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs';


@Injectable()
export class DataService {
  constructor() { }


  private dataSource = new BehaviorSubject({});
  public counterpartyTabIndex = new BehaviorSubject(0);

  currentData = this.dataSource.asObservable();
  __bIsFilterApply: boolean; // FB31641 - pawan prajapati - 12/10/2021

  /*FB 17220 Vidya 16/06/2020*/
  private __oDataLegalHierarchy = new BehaviorSubject([]);
  __oLegalHierarchy = this.__oDataLegalHierarchy.asObservable();

  private __oTCPTreeDataStore = new BehaviorSubject([]);
  __oTCPCurrentTreeDataStore = this.__oTCPTreeDataStore.asObservable();

  private __oTCPDataStore = new BehaviorSubject([]);
  __oTCPCurrentDataStore = this.__oTCPDataStore.asObservable();

  private __oCounterpartiesDataStore = new BehaviorSubject([]);
  __oCounterpartiesCurrentDataStore = this.__oCounterpartiesDataStore.asObservable();

  private __oOETreeDataStore = new BehaviorSubject([]);
  __oOECurrentTreeDataStore = this.__oOETreeDataStore.asObservable();

  private __oTradingEntitiesDataStore = new BehaviorSubject([]);
  __oTradingEntitiesCurrentDataStore = this.__oTradingEntitiesDataStore.asObservable();

  private __oSystemSystemData = new BehaviorSubject([]);
  __oSystemSettingsCurrentDataStore = this.__oSystemSystemData.asObservable();

  private __oDataGrid = new BehaviorSubject([]);
  __oDataGrids = this.__oDataGrid.asObservable();

  private __oLimitsDataGrid = new BehaviorSubject([]);
  __oLimitDataGrid = this.__oLimitsDataGrid.asObservable();

  private limitdataSource = new BehaviorSubject({});
  limitcurrentData = this.limitdataSource.asObservable();

  private __guaranteesDataGridFilter = new BehaviorSubject({}); // FB31641 - pawan prajapati - 12/10/2021
  __guaranteeDataGridFilter = this.__guaranteesDataGridFilter.asObservable(); // FB31641 - pawan prajapati - 12/10/2021

  private physicalTrackingInstance = new BehaviorSubject({});
  physicalTrackingInstanceData = this.physicalTrackingInstance.asObservable();

  private __oCPComponent = new BehaviorSubject({});
  __oCustomPopertyComponent = this.__oCPComponent.asObservable();

  //For header change
  //Using any
  private __oHeaderSource = new BehaviorSubject({});
  __oCurrentHeader = this.__oHeaderSource.asObservable();

  private portalDateFormatSubject = new BehaviorSubject<string | null>(null);
  portalDateFormat$ = this.portalDateFormatSubject.asObservable();
  
  // here we set/change value of the observable
  setData(data: any) {
    this.dataSource.next(data)
  }

  setCounterpartyTabIndex(data: any) {
    this.counterpartyTabIndex.next(data);
  }

  setIsFilterApplyData(data: any) { // FB31641 - pawan prajapati - 12/10/2021
    this.__bIsFilterApply = data;
  }

  setphysicalTrackingInstanceData(data: any) {
    this.physicalTrackingInstance.next(data)
  }

  setlimitData(data: any) {
    this.limitdataSource.next(data)
  }

  setTCPTreeStore(data: any[]) {
    this.__oTCPTreeDataStore.next(data)
  }

  setTCPStore(data: any[]) {
    this.__oTCPDataStore.next(data)
  }

  setCounterpartyStore(data: any[]) {
    this.__oCounterpartiesDataStore.next(data)
  }

  setOETreeStore(data: any[]) {
    this.__oOETreeDataStore.next(data)
  }

  setTradingEntitiesStore(data: any[]) {
    this.__oTradingEntitiesDataStore.next(data)
  }

  SetSystemSystemData(data: any[]) {
    this.__oSystemSystemData.next(data);
  }

  setDataGrids(grids: any[]) {
    this.__oDataGrid.next(grids);
  }

  setLmitDataGrid(data: any) {
    this.__oLimitsDataGrid.next(data);
  }

  setGuaranteeDataGridFilter() { // FB31641 - pawan prajapati - 12/10/2021
    this.__guaranteesDataGridFilter.next({});
  }


  setCustomPropertyComponent(data: any) {
    this.__oCPComponent.next(data)
  }

  /*FB 17220 Vidya 16/06/2020*/
  setLegalHierarchy(data: any[]) {
    this.__oDataLegalHierarchy.next(data)
  }

  setHeader(data: any) {
    this.__oHeaderSource.next(data)
  }
  
  setPortalDateFormat(format: string) {
    this.portalDateFormatSubject.next(format);
  }
}
